module.exports = __webpack_public_path__ + "static/media/teal_shapes.2be1502c.jpg";